// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/agenda?societaId&sedeId&venditoreId&da&a&annullati',
    requestBody: null,
    response: '{"success":true,"data":{"appuntamenti":"array","venditori":"array","sedi":"array","da":"string","a":"string"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
